import { Injectable } from '@angular/core'; 

import {User, Contrasenia, Logueo} from '../models/user' 
import { environment } from 'src/environments/environment'; 
import { ParameterConst } from 'src/app/util/constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, share } from 'rxjs/operators';
import { Observable } from 'rxjs';

import {Md5} from 'ts-md5/dist/md5';

@Injectable({
  providedIn: 'root'
})
export class LoginService { 
  private url_acceder = environment.apiEndpoint + "ajax/login.php";

  private url_menu = environment.apiEndpoint;

  constructor(private _http:HttpClient){}
  verifyUser(_user : User): Observable<any>{

    const formData = new FormData();
      formData.append("user", _user.username);
    formData.append("pass", _user.pass);

    return this._http.post(this.url_acceder,formData/*,

      {
        headers: new HttpHeaders({
          'Content-Type':  'application/json'
        })
      }*/


     /* {
      "user": _user.username,
      "pass": _user.pass
    }*/
    
    ).pipe(share());
  }
 /* validarIngreso(_user : Logueo){
    if(_user.username =="admin"){
      return environment.admin;
    }else if(_user.username =="supervisor"){
      return environment.supervisor;
    }else if(_user.username =="externo"){
      return environment.externo;
    }
  }
*/
 /* menuIngreso(user: Logueo){

    return this._http.post(this.url_menu+"/msgastosjudicialesintranet/mspj/usuario/menu",{
      "username": user.username,
      "pass": user.pass
    }).pipe(share());

  }*/


  logout(){
    localStorage.removeItem(ParameterConst.USER_LOGIN);
    localStorage.removeItem(ParameterConst.TOKEN);
    localStorage.removeItem(ParameterConst.TOKEN_CLIENTE);
    localStorage.removeItem(ParameterConst.USER_MENU);
  }
  
  getCurrentSession(): User{
    var sessionStr = localStorage.getItem(ParameterConst.USER_LOGIN);
    return (sessionStr) ? <User> JSON.parse(sessionStr) : null;
  }
}
 
